import { RestrictionGroupStatus } from '@libs/api/models';
import { TagStatus } from '@libs/ui/components';

export const RestrictionGroupStatusToTagStatus = {
  [RestrictionGroupStatus.CANCELED]: TagStatus.NEGATIVE,
  [RestrictionGroupStatus.VALIDATED]: TagStatus.POSITIVE,
  [RestrictionGroupStatus.PENDING]: TagStatus.PENDING,
};
